const BadgeType = {
	ThumbsUp: {
		label: 'Thumbs Up',
		key: 'thumbsUp',
		icon: 'icon-recommend-icon badge-thumbs-up',
	},
	Love: {
		label: 'Love',
		key: 'love',
		icon: 'icon-love-icon color-true-red',
	},
	ThumbsDown: {
		label: 'Thumbs Down',
		key: 'thumbsDown',
		icon: 'icon-not-recommend-icon badge-thumbs-down',
	},
	Laugh: {
		label: 'Laugh',
		key: 'laugh',
		icon: 'icon-laugh badge-laugh',
	},
};

export default BadgeType;
